<script>
  export let block;
</script>

<div class="p-16">
  <div class="container relative">
    <div class="overflow-hidden relative marquee">
      <div
        class="absolute left-0 top-0 w-[200px] h-full bg-gradient-to-r from-gray z-10"
      />
      <div class="marquee-content">
        {#each [0, 1] as _}
          <div class="marquee-inner">
            {#each [0, 1, 2, 3] as _}
              {#each block.fields as { image }}
                <img
                  src={image.url}
                  class="size-full"
                  alt={image.alt}
                  width={image.dimensions.width}
                  height={image.dimensions.height}
                />
              {/each}
            {/each}
          </div>
        {/each}
      </div>
      <div
        class="absolute right-0 top-0 w-[200px] h-full bg-gradient-to-l from-gray z-10"
      />
    </div>
  </div>
</div>

<style lang="postcss">
  .marquee {
    display: flex;
    white-space: nowrap;
    overflow: hidden;
    position: relative;
  }

  .marquee-inner {
    @apply grid auto-cols-auto grid-flow-col;

    & img {
      @apply mr-12 h-24 w-auto max-w-none object-contain lg:mr-24;
    }
  }

  .marquee-content {
    @apply flex;
    animation: marquee 60s linear infinite;
  }

  @keyframes marquee {
    from {
      transform: translateX(0%);
    }

    to {
      transform: translateX(-50%);
    }
  }
</style>
